import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface IMyWorklistFilterStoreProps {
  providerIds: string[];
  partnerId: string;
  setProviderIds: (ids: string[]) => void;
  setPartnerId: (id: string) => void;
  clearStore: () => void;
}

export const useMyWorklistStore = create<IMyWorklistFilterStoreProps>()(
  persist(
    set => ({
      providerIds: [],
      partnerId: '',
      setProviderIds: ids => set({ providerIds: ids }),
      setPartnerId: id => set({ partnerId: id }),
      clearStore: () => set({ providerIds: [], partnerId: '' }),
    }),
    {
      name: 'my-worklist-store',
    },
  ),
);
